/**
 * EFKT-MOCK DOMAIN — see `./index.ts` banner comment. Field names mirror datahub's
 * `datahub/tasks/models.ts` (`IDatahubTask`, renamed `ITask`) exactly, so a copied Booqly task
 * component reads the same properties without edits.
 */
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["Complete"] = "COMPLETE";
    TaskStatus["Partial"] = "PARTIAL";
    TaskStatus["Open"] = "NOT_DONE";
    TaskStatus["Unknown"] = "UNKNOWN";
    TaskStatus["Cancelled"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
export var TaskCategory;
(function (TaskCategory) {
    TaskCategory["BookPhotographer"] = "BOOK_PHOTOGRAPHER";
    TaskCategory["UploadImages"] = "UPLOAD_IMAGES";
    TaskCategory["UploadVideos"] = "UPLOAD_VIDEOS";
    TaskCategory["VirtualStaging"] = "VIRTUAL_STAGING";
    TaskCategory["CopywriteTexts"] = "COPYWRITE_TEXTS";
    TaskCategory["Location"] = "LOCATION";
    TaskCategory["Person"] = "PERSON";
    TaskCategory["Basic"] = "BASIC";
    TaskCategory["IntroOutroSpeak"] = "INTRO_OUTRO_SPEAK";
    TaskCategory["BasicOpt"] = "BASIC_OPT";
    TaskCategory["Text"] = "TEXT";
    TaskCategory["VirtualStagingRemoveObjects"] = "VIRTUAL_STAGING_REMOVE_OBJECTS";
    TaskCategory["VirtualStagingIndoorRenovation"] = "VIRTUAL_STAGING_INDOOR_RENOVATION";
    TaskCategory["VirtualStagingOutdoorRenovation"] = "VIRTUAL_STAGING_OUTDOOR_RENOVATION";
    TaskCategory["VirtualStaging720"] = "VIRTUAL_STAGING_720";
    TaskCategory["VirtualStagingCommercial"] = "VIRTUAL_STAGING_COMMERCIAL";
    // Typo kept for grep-parity with datahub's TaskCategory.VirtaulStagingCommercial720 — the domain
    // this mirrors kept it, so this one does too.
    TaskCategory["VirtaulStagingCommercial720"] = "VIRTUAL_STAGING_COMMERCIAL_720";
    TaskCategory["CombineImages"] = "COMBINE_IMAGES";
    TaskCategory["Arial"] = "ARIAL";
    TaskCategory["PersonInfo"] = "PERSON_INFO";
    TaskCategory["IntroOutro"] = "INTRO_OUTRO";
    TaskCategory["VidibiliComment"] = "VIDIBILI_COMMENT";
    TaskCategory["SpeakInput"] = "SPEAK_INPUT";
    TaskCategory["ComText"] = "COMTEXT";
    TaskCategory["BeforeAfter"] = "BEFORE_AFTER";
    TaskCategory["NoStyleText"] = "TEXT-STYLE";
    TaskCategory["SoMe"] = "SOCIAL_MEDIA";
    TaskCategory["SoMeSlideshow"] = "SOCIAL_MEDIA_SLIDESHOW";
    TaskCategory["SomeGif"] = "SOCIAL_MEDIA_GIF";
    TaskCategory["ImageSelector"] = "IMAGE_SELECTOR";
    TaskCategory["WhiteboxImageSelector"] = "WHITEBOX_IMAGE_SELECTOR";
    TaskCategory["AITextInput"] = "AI_TEXT_INPUT";
    TaskCategory["AITextOverview"] = "AI_TEXT_OVERVIEW";
    // Efkt's own types (AXIT-836). Values are the wire strings verbatim, unlike every member above,
    // because `tasks.categories.<value>` is the i18n key. datahub has no equivalent.
    TaskCategory["EfktUploadImage"] = "EFKT__UPLOAD_IMAGE";
    TaskCategory["EfktNoteField"] = "EFKT__NOTE_FIELD";
    TaskCategory["EfktImageSelector"] = "EFKT__IMAGE_SELECTOR";
    TaskCategory["EfktOutdoorRetouching"] = "EFKT__OUTDOOR_RETOUCHING";
    TaskCategory["EfktIndoorRetouching"] = "EFKT__INDOOR_RETOUCHING";
})(TaskCategory || (TaskCategory = {}));
